export default __webpack_public_path__ + "static/media/photo--lg--95.95ebbeee.jpg";